import { FC, useRef, useEffect, useState } from 'react'
import { useSelector, connect, useDispatch, ConnectedProps } from 'react-redux'
import { LayoutSplashScreen } from '../../../../cms/layout/core'
import * as auth from './actions'
import { RootState } from '../../../../setup'
import { service } from './service'
import { actionTypes } from './constants'
import { isEmpty } from 'lodash'
import { ISettingTypeState } from '../../siteSettings/components/settings'
import { imageBaseUrl } from 'src/cms/helpers/constants'

const mapState = (state: RootState) => ({ auth: state.auth })
const connector = connect(mapState, auth.actions)
type PropsFromRedux = ConnectedProps<typeof connector>

const AuthInit: FC<PropsFromRedux> = (props) => {
  const didRequest = useRef(false)
  const dispatch = useDispatch()
  const [showSplashScreen, setShowSplashScreen] = useState(true)
  const [splashLogo, setSplashLogo] = useState('')
  const [splashLogoAlt, setSplashLogoAlt] = useState('')
  const settingTypeData: ISettingTypeState = useSelector((state: any) => state.settingType)
  const splashScreen = document.getElementById('splash-screen')

  useEffect(() => {
    if (!isEmpty(settingTypeData?.backendData)) {
      settingTypeData?.backendData &&
        settingTypeData?.backendData['Theme settings']?.map((item: any) => {
          if (item?.name === 'loadingImage') {
            setSplashLogo(item?.value)
            setSplashLogoAlt(item?.name)
          }
        })
    }
  }, [settingTypeData])
  useEffect(() => {
    if (!isEmpty(splashLogo)) {
      let img = document.createElement('img')
      img.setAttribute('src', `${imageBaseUrl}/${splashLogo}`)
      img.setAttribute('alt', `${splashLogoAlt}`)
      img.setAttribute('class', 'h-30px')

      splashScreen?.appendChild(img)
    }
  }, [splashLogo])

  // The HttpOnly auth cookie is the only session; ask the API who we are before rendering
  useEffect(() => {
    const requestUser = async () => {
      try {
        if (!didRequest.current) {
          const [{ data: user }, moduleResponse] = await Promise.all([
            service.getUserByToken(),
            service.getModuleData().catch(() => undefined),
          ])
          dispatch({
            type: actionTypes.GET_DB_MODULE_SUCCESS,
            payload: { moduleData: moduleResponse?.data?.data?.module },
          })
          dispatch(props.fulfillUser(user))
        }
      } catch (error: any) {
        if (!didRequest.current) {
          dispatch(props.logout())
        }
      } finally {
        setShowSplashScreen(false)
      }

      return () => (didRequest.current = true)
    }
    requestUser()
  }, [])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>
}

export default connector(AuthInit)
